var CONFUSEDCMS = CONFUSEDCMS || {},
    CONFUSEDPARKINGAPP = CONFUSEDPARKINGAPP || {},
    Confused = Confused || {},
    newrelic = newrelic || {};

(function(ns, newrelic, $) {
    'use strict';

    // html elements
    ns.Elements = {
        ParkingAppWidget: 'div.parking-app-lozenge-inputs',
        ParkingAppMapWrapper: '.parking-app-map-wrapper',
        ParkingAppMapDeviceWrapper: '.parking-app-map-device-wrapper',
        ParkingAppMapSpinner: '.parking-app-map-spinner-wrapper',
        ParkingAppMapUnavailableMessage: '.parking-app-map-unavailable-message',
        ParkingAppMapErrorMessage: '.parking-app-map-error-message',
        ParkingAppResultsLoadingContainer: '.parking-app-results-loading-containter',
        ParkingAppResultsUnavailableContainer: '.parking-app-results-unavailable-containter',
        ParkingAppResultsErrorContainer: '.parking-app-results-error-containter',
        ParkingAppResultsContainer: '.parking-app-results-containter',
        ParkingAppAllSpacesTab: '#allSpacesTab',
        ParkingAppAvailableSpacesTab: '#availableSpacesTab',
        ShortTermFilter: '#shortTermFilter',
        LongTermFilter: '#longTermFilter',
        AllocatedSpaceFilter: '#allocatedSpaceFilter',
        ShelteredParkingFilter: '#shelteredParkingFilter',
        GarageFilter: '#garageFilter',
        TwentyFourSevenAccessFilter: '#twentyFourSevenAccessFilter',
        SecurityGatesFilter: '#securityGatesFilter',
        AirportTransfersFilter: '#airportTransfersFilter',
        SearchLocationSelected: '#searchLocationSelected',
        SearchChangeLocationSelected: '#searchChangeLocationSelected',
        LoadMore: '.load-more-section__link',
        ParkingAppCookieDomain: '#parkingAppCookieDomain',
        SearchPageCurrentPositionFault: '#searchPageCurrentPositionFault',
        ResultsPageCurrentPositionFault: '#resultsPageCurrentPositionFault'
    };

    // constants
    ns.Constants = {
        ShortTitleTextToRemove: 'Parking on',
        ShortDescriptionLength: 65,
        Ellipsis: '...',
        ReviewsAverageClassPartial: 'parking-space-rating--',
        SearchStep: 1,
        ResultsStep: 2,
        MaximumParkingSpaceNumber: 50,
        MaximumParkingSpaceDistance: 20,
        CurrentPositionFault: 'Unable to find your current location',
        SourceSearchSubmit: 'SearchSubmit',
        SourceLoadMore: 'LoadMore',
        SourceSearchCookie: 'SearchCookie',
        ParkingSearchCookieName: 'ParkingSearch',
        ParkingAppName: 'CarParking',
        CookieDelimiter: '+',
        PriceNumberOfDecimalPlaces: 2
    };

    // classes
    ns.Classes = {
        FilterTabActive: 'filter-tab--active'
    };

    // utils functions
    ns.Utils = {

        // bind json parking space to model
        BindParkingSpace: function(parkingSpace, jsonParkingSpace, listNumber) {
            parkingSpace.Id(jsonParkingSpace.Id);
            parkingSpace.Title(ns.Utils.ShortTitle(jsonParkingSpace.Title));
            parkingSpace.Features(jsonParkingSpace.Features);
            parkingSpace.ImageUrl(jsonParkingSpace.ImageUrl);
            parkingSpace.PriceFrom(jsonParkingSpace.PriceFrom);
            parkingSpace.PriceHourly(jsonParkingSpace.PriceMatrix.Hourly.toFixed(ns.Constants.PriceNumberOfDecimalPlaces));
            parkingSpace.PriceDaily(jsonParkingSpace.PriceMatrix.Daily.toFixed(ns.Constants.PriceNumberOfDecimalPlaces));
            parkingSpace.PriceMonthly(jsonParkingSpace.PriceMatrix.Monthly.toFixed(ns.Constants.PriceNumberOfDecimalPlaces));
            parkingSpace.SpaceType(jsonParkingSpace.SpaceType);
            parkingSpace.RentalTypes(jsonParkingSpace.RentalTypes);
            parkingSpace.Reviews(jsonParkingSpace.Reviews);
            parkingSpace.ReviewsAverageClass(ns.Utils.ReviewsAverageClass(jsonParkingSpace.Reviews));
            parkingSpace.Location(jsonParkingSpace.Location);
            parkingSpace.Distance(ns.Utils.FormattedDistance(jsonParkingSpace.Distance));
            parkingSpace.SpacesAvailable(jsonParkingSpace.Let ? false : true);
            parkingSpace.ClickthroughUrl(jsonParkingSpace.WebsiteUrl);
            parkingSpace.Description(ns.Utils.ShortDescription(jsonParkingSpace.Description));
            parkingSpace.ListNumber(listNumber);
            parkingSpace.Enabled(true);
        },

        // short title
        ShortTitle: function(title) {
            return $.trim(title.replace(ns.Constants.ShortTitleTextToRemove, ''));
        },

        // short description
        ShortDescription: function(description) {
            return $.trim(description)
                .substring(0, ns.Constants.ShortDescriptionLength)
                .trim(this) +
                ns.Constants.Ellipsis;
        },

        // reviews average class
        ReviewsAverageClass: function(reviews) {
            if (reviews.Count === 0) {
                return null;
            }

            switch (reviews.Average) {
            case 0.0:
                return ns.Constants.ReviewsAverageClassPartial + '0';
            case 0.5:
                return ns.Constants.ReviewsAverageClassPartial + '0-5';
            case 1.0:
                return ns.Constants.ReviewsAverageClassPartial + '1';
            case 1.5:
                return ns.Constants.ReviewsAverageClassPartial + '1-5';
            case 2.0:
                return ns.Constants.ReviewsAverageClassPartial + '2';
            case 2.5:
                return ns.Constants.ReviewsAverageClassPartial + '2-5';
            case 3.0:
                return ns.Constants.ReviewsAverageClassPartial + '3';
            case 3.5:
                return ns.Constants.ReviewsAverageClassPartial + '3-5';
            case 4.0:
                return ns.Constants.ReviewsAverageClassPartial + '4';
            case 4.5:
                return ns.Constants.ReviewsAverageClassPartial + '4-5';
            case 5.0:
                return ns.Constants.ReviewsAverageClassPartial + '5';
            default:
                return null;
            }
        },

        // formatted distance
        FormattedDistance: function(distance) {
            return parseFloat(distance).toFixed(1);
        },

        ValidateForm: function() {
            var form = $('#frmBody');
            //form.validate({ ignore: ':not(\':visible\')' });
            return form.valid();
        },

        WriteNewRelicPageEvent: function(eventName, eventArgs) {
            eventArgs = eventArgs || {};
            eventArgs = ns.Utils.GetCustomerFromCookies(eventArgs);
            if (newrelic && newrelic.addPageAction !== undefined)
            {
                newrelic.addPageAction(CONFUSEDPARKINGAPP.Constants.ParkingAppName + eventName, eventArgs);
            }
        },

        GetCustomerFromCookies: function(object) {
            object = object || {};
            var cookies = document.cookie.split(';'),
                xUniqueCustomerSessionIdString = 'X-UniqueCustomerSessionID',
                xUniqueCustomerCookieIdString = 'X-UniqueCustomerCookieID',
                xUniqueCustomerSessionId = '',
                xUniqueCustomerCookieId = '';

            for (var c = 0; c < cookies.length; c++) {
                if (cookies[c].indexOf(xUniqueCustomerSessionIdString) !== -1) {
                    xUniqueCustomerSessionId = cookies[c].split('=')[1];
                }
                if (cookies[c].indexOf(xUniqueCustomerCookieIdString) !== -1)
                {
                    xUniqueCustomerCookieId = cookies[c].split('=')[1];
                }
            }
            object.XUniqueCustomerSessionIDString = xUniqueCustomerSessionId;
            object.XUniqueCustomerCookieIDString = xUniqueCustomerCookieId;
            return object;
        }
    };

    // blank parking space
    ns.ParkingSpace = function () {
        var self = this;
        self.Id = ko.observable(0);
        self.Title = ko.observable('');
        self.Features = ko.observable('');
        self.ImageUrl = ko.observable('');
        self.PriceFrom = ko.observable('');
        self.PriceHourly = ko.observable(0.0);
        self.PriceDaily = ko.observable(0.0);
        self.PriceMonthly = ko.observable(0.0);
        self.SpaceType = ko.observable('');
        self.RentalTypes = ko.observable('');
        self.Reviews = ko.observable('');
        self.ReviewsAverageClass = ko.observable('');
        self.Location = ko.observable('');
        self.Distance = ko.observable('');
        self.Quote = ko.observable('');
        self.Description = ko.observable('');
        self.SpacesAvailable = ko.observable(false);
        self.ClickthroughUrl = ko.observable('');
        self.ListNumber = ko.observable(0);
        self.Enabled = ko.observable(true);
    };

    // blank parking filter
    ns.ParkingFilter = function () {
        var self = this;
        self.SpacesAvailable = ko.observable(false);
        self.ShortTerm = ko.observable(true);
        self.LongTerm = ko.observable(true);
        self.AllocatedSpace = ko.observable(false);
        self.ShelteredParking = ko.observable(false);
        self.Garage = ko.observable(false);
        self.TwentyFourSevenAccess = ko.observable(false);
        self.SecurityGates = ko.observable(false);
        self.AirportTransfers = ko.observable(false);
    };

    // parking app form
    ns.ParkingAppForm = function () {
        var self = this;
        self.currentStep = ko.observable(ns.Constants.SearchStep);
        self.Autocomplete = '';
        self.Place = '';
        self.Map = '';
        self.Markers = [];
        self.MapInUse = false;
        self.ParkingSpaces = new ko.observableArray();
        self.ParkingFilter = ko.observable(new ns.ParkingFilter());
        self.ParkingSpacesPageNumber = ko.observable(0);
        self.ParkingSpacesListNumber = ko.observable(0);
        self.FeatureFilterCount = ko.observable(0);
        self.IsSearching = ko.observable(false);
        self.CookieDomain = $(ns.Elements.ParkingAppCookieDomain).val();
        self.LocationLatitude = '';
        self.LocationLongitude = '';
        self.SearchAddress = '';
        self.PlaceId = '';
        self.IsUseCurrentPosition = false;

        // initialise form
        self.Initialise = function () {

            // bind to knockout
            ko.applyBindings(self, document.getElementById('main'));

            // on timeout
            setTimeout(function () {

                var placesApiUrl = $('div.parking-app').data('placesApiUrl');
                if (placesApiUrl === '') {
                    return;
                }
                // load google places library
                $.ajax({
                    type: 'GET',
                    url: placesApiUrl,
                    dataType: 'script',
                    cache: true,
                    success: function () {

                        // set up autocomplete
                        self.Autocomplete = CONFUSEDPARKINGAPP.Search.initAutocomplete();
                    }
                });

                // bind filter events
                self.bindFilterEvents();

                // handle search cookie
                var parkingSearchCookieValue = Confused.CookieManager.prototype.getItem(ns.Constants.ParkingSearchCookieName);
                if (parkingSearchCookieValue !== null) {
                    self.handleSearchCookie(parkingSearchCookieValue);
                }

                // handle internet explorer
                self.handleInternetExplorer();

            }, 200);
        };

        // search parking spaces
        self.searchParkingSpaces = function () {

            // get search address
            self.SearchAddress = self.getAddressFromSearchbox();

            // handle validation
            if (!ns.Utils.ValidateForm()) {
                return;
            }

            // handle google places
            if (!self.IsUseCurrentPosition) {
                self.Place = CONFUSEDPARKINGAPP.Search.getPlace(self.Autocomplete);
            }

            if (!self.Place) {
                $(ns.Elements.ParkingAppResultsErrorContainer).show();
                $(ns.Elements.ParkingAppResultsContainer).hide();
                $(ns.Elements.ParkingAppMapWrapper).hide();
                return;
            } else {
                $(ns.Elements.ParkingAppResultsErrorContainer).hide();
            }

            // get place id
            self.PlaceId = self.Place.place_id;

            // get latitude and longitude
            self.LocationLatitude = self.Place.geometry.location.lat();
            self.LocationLongitude = self.Place.geometry.location.lng();

            // set page and list number
            self.ParkingSpacesPageNumber(1);
            self.ParkingSpacesListNumber(1);

            // reset filter
            self.ParkingFilter(new ns.ParkingFilter());
            self.FeatureFilterCount(0);

            // clear existing parking spaces
            self.ParkingSpaces.removeAll();

            // prepare results page
            self.prepareResultsPage();

            // get parking spaces
            self.getParkingSpaces(ns.Constants.SourceSearchSubmit);
        };

        // load more parking spaces
        self.loadMoreParkingSpaces = function () {

            // increment parking spaces page number
            self.ParkingSpacesPageNumber(self.ParkingSpacesPageNumber() + 1);

            // get parking spaces
            self.getParkingSpaces(ns.Constants.SourceLoadMore);
        };

        // get parking spaces
        self.getParkingSpaces = function (source) {

            // clear search box
            self.clearAddressFromSearchbox();

            // hide parking spaces unavailable messages
            self.hideParkingSpacesUnavailableMessages();

            // hide parking spaces results container
            $(ns.Elements.ParkingAppResultsContainer).hide();

            // show loading message and spinner...
            $(ns.Elements.ParkingAppResultsLoadingContainer).show();

            // handle map loading
            self.handleMapLoading();

            // enable 'is searching'
            if (self.IsSearching()) {
                return;
            }
            self.IsSearching(true);

            // make ajax request for parking spaces
            $.ajax({
                url: '/api/parkingv2/parkingapp/GetParkingSpaces',
                data: ko.toJSON({
                    LocationLatitude: self.LocationLatitude,
                    LocationLongitude: self.LocationLongitude,
                    PageNumber: self.ParkingSpacesPageNumber(),
                    SearchAddress: self.SearchAddress,
                    GooglePlaceId: self.PlaceId,
                    Source: source
                }),
                type: 'POST',
                contentType: 'text/json',
                success: function (parkingSpaces) {

                    // disable 'is searching'
                    self.IsSearching(false);

                    // clear current postion
                    self.IsUseCurrentPosition = false;

                    // set up autocomplete
                    self.Autocomplete = CONFUSEDPARKINGAPP.Search.initAutocomplete();

                    // hide loading message and spinner...
                    $(ns.Elements.ParkingAppResultsLoadingContainer).hide();

                    // show parking spaces unavailable messages
                    if (parkingSpaces.result === false) {
                        self.showParkingSpacesUnavailableMessages();
                        return;
                    }

                    // bind retrieved parking spaces
                    self.bindParkingSpaces(parkingSpaces);

                    // show parking spaces unavailable messages
                    if (self.ParkingSpaces().length === 0) {
                        self.showParkingSpacesUnavailableMessages();
                        return;
                    }

                    // show parking spaces results container
                    $(ns.Elements.ParkingAppResultsContainer).show();

                    // reapply filter on 'load more'
                    if (self.getFilterCount() > 0) {
                        self.handleFilterEvent();
                    }

                    // handle map
                    self.handleMap();
                },
                error: function () {

                    // reset
                    self.IsSearching(false);
                    self.IsUseCurrentPosition = false;
                    self.Autocomplete = CONFUSEDPARKINGAPP.Search.initAutocomplete();

                    // show error
                    $(ns.Elements.ParkingAppResultsLoadingContainer).hide();
                    $(ns.Elements.ParkingAppResultsErrorContainer).show();
                    self.handleMapError();

                },
                timeout: 20000
            });
        };

        // bind parking spaces
        self.bindParkingSpaces = function (parkingSpaces) {

            // sort spaces by distance
            parkingSpaces.JsonViewSpaces.sort(function (left, right) {
                return parseFloat(left.Distance) - parseFloat(right.Distance);
            });

            $.each(parkingSpaces.JsonViewSpaces, function (index, space) {
                if (space !== false) {
                    var modelSpace = new ns.ParkingSpace();
                    var jsonSpace = $.parseJSON(space);

                    // check within maximum number and distance
                    if (self.ParkingSpacesListNumber() > ns.Constants.MaximumParkingSpaceNumber ||
                        ns.Utils.FormattedDistance(jsonSpace.Distance) > ns.Constants.MaximumParkingSpaceDistance) {

                        // log mi
                        CONFUSEDPARKINGAPP.submitDisplayLimit(
                            self.SearchAddress,
                            self.Place.place_id,
                            self.ParkingSpacesListNumber(),
                            ns.Constants.MaximumParkingSpaceNumber,
                            ns.Utils.FormattedDistance(jsonSpace.Distance),
                            ns.Constants.MaximumParkingSpaceDistance);

                        // decrement list number
                        self.ParkingSpacesListNumber(self.ParkingSpacesListNumber() - 1);

                        // hide load more
                        $(ns.Elements.LoadMore).hide();

                        return false;
                    }

                    // bind and add parking space
                    ns.Utils.BindParkingSpace(modelSpace, jsonSpace, self.ParkingSpacesListNumber());
                    self.ParkingSpaces.push(modelSpace);

                    // increment parking space list number
                    self.ParkingSpacesListNumber(self.ParkingSpacesListNumber() + 1);

                    // hide load more
                    if (self.ParkingSpacesListNumber() === ns.Constants.MaximumParkingSpaceNumber) {
                        $(ns.Elements.LoadMore).hide();
                    }
                }
            });
        };

        // handle map
        self.handleMap = function () {
            // ensure map enabled
            if (self.isMapDeviceEnabled()) {
                self.MapInUse = true;
            } else {
                self.MapInUse = false;
                return;
            }

            // set up map
            if (!self.Map) {
                self.Map = CONFUSEDPARKINGAPP.Map.initMap();
            }

            // handle map error
            if (self.Map === null) {
                self.handleMapError();
                return;
            }

            // add parking spaces to map
            self.Markers = CONFUSEDPARKINGAPP.Map.addParkingSpacesToMap(
                self.ParkingSpaces(),
                self.Map,
                self.Markers,
                {
                    LocationLatitude: self.LocationLatitude,
                    LocationLongitude: self.LocationLongitude,
                    SearchAddress: self.SearchAddress,
                    PlaceId: self.PlaceId,
                    ParkingSearchCookieName: ns.Constants.ParkingSearchCookieName,
                    CookieDomain: self.CookieDomain,
                    CookieDelimiter: ns.Constants.CookieDelimiter
                });

            // handle map error
            if (self.Markers === null)
            {
                self.handleMapError();
                return;
            }

            // handle map loaded
            self.handleMapLoaded();
        };

        // is map device enabled
        self.isMapDeviceEnabled = function () {
            return $(ns.Elements.ParkingAppMapDeviceWrapper).is(':visible') === true;
        };

        // handle map loading
        self.handleMapLoading = function () {
            $(ns.Elements.ParkingAppMapWrapper).hide();
            $(ns.Elements.ParkingAppMapErrorMessage).hide();
            $(ns.Elements.ParkingAppMapSpinner).show();
            
        };

        // handle map error
        self.handleMapError = function () {
            $(ns.Elements.ParkingAppMapSpinner).hide();
            $(ns.Elements.ParkingAppMapWrapper).hide();
            $(ns.Elements.ParkingAppMapErrorMessage).show();

            CONFUSEDPARKINGAPP.Utils.WriteNewRelicPageEvent('MapRenderFailed');
        };

        // handle map loaded
        self.handleMapLoaded = function () {
            $(ns.Elements.ParkingAppMapSpinner).hide();
            $(ns.Elements.ParkingAppMapErrorMessage).hide();
            $(ns.Elements.ParkingAppMapWrapper).show();
            CONFUSEDPARKINGAPP.Utils.WriteNewRelicPageEvent('MapRender');
        };

        // on window resize
        $(window).resize(function () {
            self.handleMapOnWindowResize();
        });

        // submit search on 'enter' key press
        $(document).on('keydown',function (e) {
            if (e.keyCode === 13) {
                self.searchParkingSpaces();
            }
        });

        // handle map on window resize
        self.handleMapOnWindowResize = function () {
            // ensure on results page
            if (self.currentStep() !== ns.Constants.ResultsStep) {
                return;
            }

            // if window resize causes map to become enabled
            if ((self.MapInUse === false) &&
                (self.isMapDeviceEnabled() === true)) {
                self.handleMap();
            }
            // else if window resize causes map to become disabled
            else if ((self.MapInUse === true) &&
                     (self.isMapDeviceEnabled() === false)) {
                self.handleMap();
            }
        };

        // all spaces tab
        self.allSpacesTab = function () {

            // set filter
            self.ParkingFilter().SpacesAvailable(false);

            // handle filter event
            self.handleFilterEvent();

            // set active tab
            $(ns.Elements.ParkingAppAllSpacesTab).addClass(ns.Classes.FilterTabActive);
            $(ns.Elements.ParkingAppAvailableSpacesTab).removeClass(ns.Classes.FilterTabActive);
        };

        // available spaces tab
        self.availableSpacesTab = function () {

            // set filter
            self.ParkingFilter().SpacesAvailable(true);

            // handle filter event
            self.handleFilterEvent();

            // set active tab
            $(ns.Elements.ParkingAppAvailableSpacesTab).addClass(ns.Classes.FilterTabActive);
            $(ns.Elements.ParkingAppAllSpacesTab).removeClass(ns.Classes.FilterTabActive);
        };

        // bind filter events
        self.bindFilterEvents = function () {
            $(ns.Elements.ShortTermFilter).change(function () {self.handleFilterEvent();});
            $(ns.Elements.LongTermFilter).change(function () {self.handleFilterEvent();});
            $(ns.Elements.AllocatedSpaceFilter).change(function () {self.handleFilterEvent();});
            $(ns.Elements.ShelteredParkingFilter).change(function () {self.handleFilterEvent();});
            $(ns.Elements.GarageFilter).change(function () {self.handleFilterEvent();});
            $(ns.Elements.TwentyFourSevenAccessFilter).change(function () {self.handleFilterEvent();});
            $(ns.Elements.SecurityGatesFilter).change(function () {self.handleFilterEvent();});
            $(ns.Elements.AirportTransfersFilter).change(function () {self.handleFilterEvent();});
        };

        // handle filter events
        self.handleFilterEvent = function () {
            setTimeout(function () {

                // filter the parking spaces
                self.ParkingSpaces(
                    CONFUSEDPARKINGAPP.Filter.handleFilter(self.ParkingFilter(), self.ParkingSpaces())
                );

                // log mi
                CONFUSEDPARKINGAPP.submitFilter(self.ParkingFilter());

                // set feature filter count
                self.FeatureFilterCount(self.getFeatureFilterCount());

                // show parking spaces unavailable messages
                if (self.isParkingSpacesAvailable() === false) {
                    self.showParkingSpacesUnavailableMessages();
                    return;
                }

                // hide parking spaces unavailable messages
                self.hideParkingSpacesUnavailableMessages();

                // handle map
                self.handleMap();

            }, 200);
        };

        // is parking spaces available
        self.isParkingSpacesAvailable = function () {
            var isParkingSpacesEnabled = false;
            $.each(self.ParkingSpaces(), function (index, space) {
                if (space.Enabled()) {
                    isParkingSpacesEnabled = true;
                }
            });
            return isParkingSpacesEnabled;
        };

        // show parking spaces unavailable messages
        self.showParkingSpacesUnavailableMessages = function () {
            $(ns.Elements.ParkingAppMapWrapper).hide();
            $(ns.Elements.ParkingAppMapSpinner).hide();
            $(ns.Elements.ParkingAppResultsContainer).hide();
            $(ns.Elements.ParkingAppMapUnavailableMessage).show();
            $(ns.Elements.ParkingAppResultsUnavailableContainer).show();
        };

        // hide parking spaces unavailable messages
        self.hideParkingSpacesUnavailableMessages = function () {
            $(ns.Elements.ParkingAppMapWrapper).show();
            $(ns.Elements.ParkingAppResultsContainer).show();
            $(ns.Elements.ParkingAppMapUnavailableMessage).hide();
            $(ns.Elements.ParkingAppResultsUnavailableContainer).hide();
        };

        // get feature filter count
        self.getFeatureFilterCount = function () {
            var featureFilterCount = 0;

            if (self.ParkingFilter().AllocatedSpace()) { featureFilterCount++; }
            if (self.ParkingFilter().ShelteredParking()) { featureFilterCount++; }
            if (self.ParkingFilter().Garage()) { featureFilterCount++; }
            if (self.ParkingFilter().TwentyFourSevenAccess()) { featureFilterCount++; }
            if (self.ParkingFilter().SecurityGates()) { featureFilterCount++; }
            if (self.ParkingFilter().AirportTransfers()) { featureFilterCount++; }

            return featureFilterCount;
        };

        // get filter count
        self.getFilterCount = function () {
            var filterCount = self.getFeatureFilterCount();

            if (self.ParkingFilter().SpacesAvailable()) { filterCount++; }
            if (self.ParkingFilter().ShortTerm() === false) { filterCount++; }
            if (self.ParkingFilter().LongTerm() === false) { filterCount++; }

            return filterCount;
        };

        // use current position lat/lng
        self.useCurrentPosition = function () {

            function processGeolocation(position) {
                CONFUSEDPARKINGAPP.Utils.WriteNewRelicPageEvent('CurrentPosition');

                // set up Google reverse geocoding
                var geocoder = new google.maps.Geocoder();

                // get lat/lng of current position
                var latlng = { lat: parseFloat(position.coords.latitude), lng: parseFloat(position.coords.longitude) };

                // handle reverse geocoding
                geocoder.geocode({ 'location': latlng }, function (results, status) {

                    if (status === 'OK') {

                        if (results[1]) {

                            // obtain Google Place
                            var place = results[1];

                            if (place === null || place === undefined || !place.geometry) {
                                CONFUSEDPARKINGAPP.Utils.WriteNewRelicPageEvent('ReverseGeocodingPlaceFailed');
                                self.handleCurrentPositionFault();
                            }

                            // set place
                            self.Place = place;

                            // set current position
                            self.IsUseCurrentPosition = true;

                            // if on landing page...
                            if ($('#parkingAppSearchBox').is(':visible')) {

                                // update search box with Google Place formatted address
                                $('#parkingAppSearchBox').val(self.Place.formatted_address);

                                // set search as selected
                                if (!$(ns.Elements.SearchLocationSelected).is(':checked')) {
                                    $(ns.Elements.SearchLocationSelected).click();
                                }

                            // else on results page
                            } else {

                                // update search box with Google Place formatted address
                                $('#parkingAppChangeSearchBox').val(self.Place.formatted_address);

                                // set search as selected
                                if (!$(ns.Elements.SearchChangeLocationSelected).is(':checked')) {
                                    $(ns.Elements.SearchChangeLocationSelected).click();
                                }
                            }

                            // log mi
                            CONFUSEDPARKINGAPP.submitCurrentPosition(
                                position.coords.latitude,
                                position.coords.longitude,
                                self.getAddressFromSearchbox(),
                                self.Place.place_id);

                            CONFUSEDPARKINGAPP.Utils.WriteNewRelicPageEvent('ReverseGeocoding');
                        }
                    } else {
                        CONFUSEDPARKINGAPP.Utils.WriteNewRelicPageEvent('ReverseGeocodingFailed');
                        self.handleCurrentPositionFault();
                    }
                });
            }

            function geolocationError() {
                CONFUSEDPARKINGAPP.Utils.WriteNewRelicPageEvent('CurrentPositionFailed');
                self.handleCurrentPositionFault();
            }

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    processGeolocation,
                    geolocationError,
                    {
                        timeout: 5000,
                        enableHighAccuracy: true,
                        maximumAge: 0
                    });
            } else {
                CONFUSEDPARKINGAPP.Utils.WriteNewRelicPageEvent('CurrentPositionUnavailable');
                self.handleCurrentPositionFault();
            }

            return false;
        };

        // handle current position fault
        self.handleCurrentPositionFault = function () {

            // set fault
            if ($('#parkingAppSearchBox').is(':visible')) {
                $(ns.Elements.SearchPageCurrentPositionFault).prop('checked', true);
            } else {
                $(ns.Elements.ResultsPageCurrentPositionFault).prop('checked', true);
            }

            // force validation
            ns.Utils.ValidateForm();

            // reset fault
            if ($('#parkingAppSearchBox').is(':visible')) {
                $(ns.Elements.SearchPageCurrentPositionFault).prop('checked', false);
            } else {
                $(ns.Elements.ResultsPageCurrentPositionFault).prop('checked', false);
            }
        };

        // handle clickthrough
        self.handleClickthrough = function (clickthroughUrl, id, priceHourly, priceDaily, priceMonthly, distance, source) {

            //log mi
            CONFUSEDPARKINGAPP.submitClickthrough(clickthroughUrl, id, priceHourly, priceDaily, priceMonthly, distance, source);

            // create parking search cookie
            var cookieValue = self.LocationLatitude + ns.Constants.CookieDelimiter +
                self.LocationLongitude + ns.Constants.CookieDelimiter +
                self.SearchAddress + ns.Constants.CookieDelimiter +
                self.PlaceId;

            Confused.CookieManager.prototype.setItem(ns.Constants.ParkingSearchCookieName, cookieValue, null, '/', self.CookieDomain);

            // redirect to clickthrough url
            setTimeout(function () {
                window.open(clickthroughUrl, '_self');
            }, 50);
        };

        // get address from searchbox
        self.getAddressFromSearchbox = function () {

            // try getting address from results page first
            var changeSearchBox = $('#parkingAppChangeSearchBox').val();
            if (changeSearchBox) {
                return changeSearchBox;
            }

            // otherwise get address from landing page
            var searchBox = $('#parkingAppSearchBox').val();
            if (searchBox) {
                return searchBox;
            }

            return '';
        };

        // clear address from searchbox
        self.clearAddressFromSearchbox = function () {
            $('#parkingAppSearchBox').val('');
            $('#parkingAppChangeSearchBox').val('');
        };

        // get search address
        self.handleSearchCookie = function (parkingSearchCookieValue) {

            // remove search cookie
            Confused.CookieManager.prototype.removeItem(ns.Constants.ParkingSearchCookieName, '/', self.CookieDomain);

            // get cookie values
            var cookieValues = parkingSearchCookieValue.split(ns.Constants.CookieDelimiter);
            if (cookieValues.length !== 4) {
                return;
            }

            // get search address and place id
            self.SearchAddress = cookieValues[2];
            self.PlaceId = cookieValues[3];

            // get location latitude and longitude
            self.LocationLatitude = cookieValues[0];
            self.LocationLongitude = cookieValues[1];

            // set page and list number
            self.ParkingSpacesPageNumber(1);
            self.ParkingSpacesListNumber(1);

            // prepare results page
            self.prepareResultsPage();

            // get parking spaces
            self.getParkingSpaces(ns.Constants.SourceSearchCookie);
        };

        // prepare results page
        self.prepareResultsPage = function () {

            //attempt to try and hide all bands
            $('.scaffold.band').not('.global-header, .global-header__secondary, .global-footer-band').hide();

            // show load more button
            $(ns.Elements.LoadMore).show();

            // display results page
            self.currentStep(ns.Constants.ResultsStep);
        };

        // handle internet explorer
        self.handleInternetExplorer = function () {
            var ua = window.navigator.userAgent;
            var isMsIe = ua.indexOf('MSIE ') !== -1;
            var isMsIe11 = ua.indexOf('Trident/') !== -1;

            if (isMsIe || isMsIe11) {

                // pad filter options
                $('.advanced-filters-list__item input[type=checkbox] + label').css('padding-left', '30px');
            }
        };
    };

    ns.jQueryValidateExtensions = function () {

        $.validator.addMethod(
            'addressSelectedIfElementVisible',
            function (value, element, param) {
                var $element = jQuery(element);
                var $inputElement = jQuery(param[0]);

                if (!$inputElement.is(':visible')) {
                    return true;
                }

                // supress if current location fault occurred
                if ($(jQuery(param[1])).prop('checked')) {
                    return true;
                }

                if ($element.is('[type=checkbox]')) {
                    return $element.is(':checked');
                }

                return true;
            },
            'Please check your input.'
        );

        $.validator.addMethod(
            'notdefaultIfElementVisible',
            function (value, element, param) {
                var $inputElement = jQuery(param[1]);

                if (!$inputElement.is(':visible')) {
                    return true;
                }

                // supress if current location fault occurred
                if ($(jQuery(param[2])).prop('checked')) {
                    return true;
                }

                if ($inputElement.val() === param[0]) {
                    return false;
                }

                return true;
            },
            'Please check your input.'
        );

        $.validator.addMethod(
            'currentPositionFault',
            function (value, element, param) {
                var $inputElement = jQuery(param[0]);

                if (!$inputElement.is(':visible')) {
                    return true;
                }

                if (element.checked) {
                    return false;
                }

                return true;
            },
            'Please check your input.'
        );

    };

    ns.carParkingRules = function () {

        function addRule(validator, $form, validationRule) {
            var $elem = $form.find(validationRule.selector);

            if ($elem.length !== 0) {
                $elem.rules('add', validationRule.rules);
            }
        }

        var ValidationDefinition = function (selector, rules, message) {
            this.selector = selector;
            this.rules = rules;
            this.message = message;
        };


        function hookupForm($form, validators, options) {
            if (!$form) {
                throw '$form is undefined!';
            }

            //exit early if form isn't found
            if ($form.length === 0) {
                return;
            }
            options = options || {};

            var validator = $form.validate(options);

            for (var i = 0; i < validators.length; i++) {
                var validationRule = validators[i];
                addRule(validator, $form, validationRule);
            }
        }

        var validationRules = {

            SearchSelected: new ValidationDefinition('input#searchLocationSelected', {
                notdefaultIfElementVisible: ['', 'input#parkingAppSearchBox', 'input#searchPageCurrentPositionFault'],
                addressSelectedIfElementVisible: ['input#parkingAppSearchBox', 'input#searchPageCurrentPositionFault'],
                messages: {
                    notdefaultIfElementVisible: 'Please tell us where you&apos;d like to park.',
                    addressSelectedIfElementVisible: 'Please select a location from the list'
                }
            }),
            SearchChangeSelected: new ValidationDefinition('input#searchChangeLocationSelected', {
                notdefaultIfElementVisible: ['', 'input#parkingAppChangeSearchBox', 'input#resultsPageCurrentPositionFault'],
                addressSelectedIfElementVisible: ['input#parkingAppChangeSearchBox', 'input#resultsPageCurrentPositionFault'],
                messages: {
                    notdefaultIfElementVisible: 'Please tell us where you&apos;d like to park.',
                    addressSelectedIfElementVisible: 'Please select a location from the list'
                }
            }),
            SearchPageCurrentPositionFault: new ValidationDefinition('input#searchPageCurrentPositionFault', {
                currentPositionFault: ['input#parkingAppSearchBox'],
                messages: {
                    currentPositionFault: ns.Constants.CurrentPositionFault
                }
            }),
            ResultsPageCurrentPositionFault: new ValidationDefinition('input#resultsPageCurrentPositionFault', {
                currentPositionFault: ['input#parkingAppChangeSearchBox'],
                messages: {
                    currentPositionFault: ns.Constants.CurrentPositionFault
                }
            })
        };

        return {
            hookup: hookupForm,
            validationRules: validationRules
        };

    };

    ns.setUpValidation = function ($form) {
        ns.jQueryValidateExtensions();

        var carParkingRules = ns.carParkingRules();
        carParkingRules.hookup($form, [
            carParkingRules.validationRules.SearchSelected,
            carParkingRules.validationRules.SearchChangeSelected,
            carParkingRules.validationRules.SearchPageCurrentPositionFault,
            carParkingRules.validationRules.ResultsPageCurrentPositionFault
        ],
        {
            errorElement: 'div',
            errorClass: 'error-message',
            errorPlacement: function (error, element) {
                element.parent().find('div.error-placement').append(error);
            },
            onfocusout: function (element) {
                if ((!$(element).hasClass('ignore')) && $(element).hasClass('notdefault') || (!this.checkable(element) && (element.name in this.submitted || !this.optional(element)))) {
                    this.element(element);
                }
            },
            onblur: function (element) {
                if ((!$(element).hasClass('ignore')) && $(element).hasClass('notdefault') || (!this.checkable(element) && (element.name in this.submitted || !this.optional(element)))) {
                    this.element(element);
                }
            },
            ignore: ''

        });
    };

    // set up parking app form
    if ($(ns.Elements.ParkingAppWidget).length > 0) {
        var parkingAppForm = new CONFUSEDPARKINGAPP.ParkingAppForm();
        parkingAppForm.Initialise();
        CONFUSEDPARKINGAPP.setUpValidation($('#frmBody'));
    }



})(CONFUSEDPARKINGAPP, newrelic, jQuery);



